<template>
    <div class="gh-page gh-page--mcd">
        <section class="gh-section">
            <div class="container">
                <h1 class="gh-section__heading">Retrieve Your Tax Invoice</h1>
                <br>
                <p>To generate a receipt for your event payment, please enter your email address (this must be the same email you used to register) below and click "Get Tax Invoice."</p>

                <gh-form event-type="summit" ref="form"/>
            </div>
        </section>
    </div>
</template>

<script>
  import ghForm from '@/modules/events/document/components/FormInvoice'
  import store from '@/modules/events/document/store';

  export default {
    name: 'GhSuicidePreventionCertificate',

    components: {
      ghForm
    },

    created() {
      !this.$store.state.eventDocument && this.$store.registerModule('eventDocument', store);
    },

    mounted () {
      if (this.$route.query.email) {
        this.$refs.form.form.email = this.$route.query.email
      }
    }
  }
</script>

<style lang="scss" scoped>
    ol {
        padding-left: 1rem;
        color: #333;
        font-size: 18px;
        font-weight: 500;
    }

    .gh-form {
        max-width: 680px;
        margin-top: 2rem;
    }

    .gh-form__actions {
        margin-top: 2rem;
    }
</style>
